import { render, staticRenderFns } from "./AttendGroupView.vue?vue&type=template&id=02e37dd8&scoped=true&"
import script from "./AttendGroupView.vue?vue&type=script&lang=js&"
export * from "./AttendGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e37dd8",
  null
  
)

export default component.exports